import { IQuantity, Quantity } from "../../../common/models/quantity.model";

interface IActions {
    openPanelToAdd: () => void,
    openPanelToEdit: () => void,
    deleteVehicle: () => void
}

export const generateItems = (
  quantity: IQuantity,
  actions: IActions,
  t: any,
) => {
  switch (quantity) {
    case Quantity.NONE:
      return [
        {
            key: "add",
            text: t('vehicles.commands.add'),
            iconProps: { iconName: "add" },
            name: "add",
            onClick: actions.openPanelToAdd
          },
      ];
    case Quantity.ONE:
      return [
        {
          key: "add",
          text: t('vehicles.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.openPanelToAdd
        },
        {
          key: "edit",
          text: t('vehicles.commands.edit'),
          iconProps: { iconName: "edit" },
          name: "edit",
          onClick: actions.openPanelToEdit,
        },
        {
          key: "delete",
          text: t('vehicles.commands.delete'),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.deleteVehicle,
        },
      ];
    default:
      return [];
  }
};